import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '../../../node_modules/@angular/router';
import { AuthService } from '../_services/auth.service';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';
import { NavbarService } from '../_services/navbar.service';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { SupportDataForm } from '../_models/support-data-form';
import { SupportService } from '../_services/support.service';
import { SnotifyService } from 'ng-snotify';
import { LearningStatusService } from '../_services/learning-status.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {
  supportDataForm: SupportDataForm = new SupportDataForm();
  userDataSession;
  userDisplayName = '';
  firstName = '';
  lastName = '';
  userFullName = '';
  firstCharacter = '';
  userRoleId = 0;
  nda = 0;
  userRoleName = '';
  showNavBar = false;
  homeStatus: boolean = true;
  homeMarginLeft: number;
  navItemSelected: string = '';
  public innerWidth: any;
  userDetailsId = 0;
  urlString: string = '';
  learningpartStatus: boolean = false;

  get createProjectTooltip(): string {
    return this.learningStatusService.createProjectTooltip;
  }
  set createProjectTooltip(value: string) {
    this.learningStatusService.createProjectTooltip = value;
  }
  get projectButtonStatus(): boolean {
    return this.learningStatusService.projectButtonStatus;
  }
  set projectButtonStatus(value: boolean) {
    this.learningStatusService.projectButtonStatus = value;
  }
  // ===== Navigation bar menu item value =====
  navMenu: INavMenu[] = [];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    public spinnerService: SpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private navbarService: NavbarService,
    private sesssionActivityService: SesssionActivityService,
    private learningStatusService: LearningStatusService,
    private supportService: SupportService,
    private snotifyService: SnotifyService,
  ) {
    this.activatedRoute.params.subscribe(params => {
    });
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.navMenu = this.navbarService.getNavMenu();

    this.authService.checkUserSession();

    const currentUser = localStorage.getItem('currentUser');

    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userRoleId = this.userDataSession.userRoleId;
      this.userDetailsId = this.userDataSession.userDetailsId;
      this.nda = this.userDataSession.nda;
      if (this.userDataSession.fullName) {
        this.userFullName = this.userDataSession.fullName;
        this.userRoleName = this.userDataSession.userRoleName;

        this.firstName = this.userDataSession.firstName;
        this.lastName = this.userDataSession.lastName;
        // Show First Character of first Name and Last Name as profile pic
        this.userDisplayName = this.firstName.charAt(0) + this.lastName.charAt(0);
      }
    }
    this.learningStatusService.getLearningSatatus(this.userDataSession.userDetailsId);
  }

  // ===== Navigation bar menu item value passed to learning status component =====
  sendNavItemValue(itemValue: string): void {
    this.navItemSelected = itemValue;
    this.learningpartStatus = true;
    this.navbarService.saveActiveNavItem(this.navItemSelected);
  }

  goToCreateProject() {
    if (this.nda === 0) {
      this.router.navigate(['/main/nda']);
    } else {
      this.router.navigate(['/main/basicInventionDetails']);
    }
  }

  sendSupport(supportDetails: any): void {
    if (supportDetails.description) {
      this.spinnerService.show();
      this.supportDataForm.userDetailsId = this.userDetailsId;
      this.supportDataForm.enquiryMessage = supportDetails.description;
      this.supportDataForm.imageUrl = supportDetails.screenshot;
      this.supportDataForm.currentPageUrl = window.location.href;
      this.supportService.saveSupportDetails(this.supportDataForm).subscribe(
        resp => {
          this.spinnerService.hide();
          this.snotifyService.success("Your enquiry has been submitted successfully");
        },
        error => {
          this.spinnerService.hide();
          console.log(error);
        })
    }
  }

  public logoutCall() {
    // Show Spinner
    this.spinnerService.show();
    this.authService.logout();
  }

  public changePassword() {
    this.router.navigate(['/user/changePassword']);
  }
}

// ===== Navigation bar menu item interface =====
export interface INavMenu {
  title: string;
  disableOption: boolean;
}
